import React from 'react';
import { Box, Typography } from '@mui/material';

const PageBanner = ({ title, image }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '350px',
        position: 'relative',
        borderRadius: '16px',
        overflow: 'hidden',
        mb: -4, // Overlap with summary box
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)', // Dark overlay
          }
        }}
      />
      
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          color: 'white',
          width: '90%',
          maxWidth: '800px'
        }}
      >
        <Typography 
          variant="h1" 
          sx={{ 
            fontSize: { xs: '2.5rem', md: '4rem' }, 
            fontWeight: 800, 
            textShadow: '2px 2px 10px rgba(0,0,0,0.5)',
            fontFamily: "'Outfit', sans-serif"
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default PageBanner;
